var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"edit-button --base-color --underline-effect",attrs:{"to":{ name: 'editPostById', params: { id: _vm.postId } }}},[_vm._v("edit")])}
var staticRenderFns = []

export { render, staticRenderFns }